import { useEffect } from 'react'
import axios, { AxiosResponse } from 'axios'

import { State, useFetchState } from './useFetchState'
import { generateErrorFromResponse } from '../utils/errorHelper'

export interface ReturnType<T> {
  state: State<T>
  callApi: (apiCall: Promise<AxiosResponse<any>>) => Promise<any>
  setIdle: () => void
}

export function useApi<T>(): ReturnType<T> {
  const { state, setLoading, setSuccess, setError, setIdle } = useFetchState()

  useEffect(() => {
    const source = axios.CancelToken.source()

    const interceptorNumber = axios.interceptors.request.use((config) => {
      config.cancelToken = source.token
      return config
    })

    return () => {
      source.cancel('Llamada cancelada.')
      axios.interceptors.request.eject(interceptorNumber)
    }
  }, [])

  const callApi = (apiCall: Promise<AxiosResponse<any>>) => {
    setLoading()
    return new Promise((resolve, reject) => {
      apiCall
        .then(({ data }) => {
          setSuccess(data)
          resolve(data)
        })
        .catch((error) => {
          const errorMessage = generateErrorFromResponse({
            data: error.response?.data ?? error.data ?? error.message
          })
          setError(errorMessage)
          reject(errorMessage)
        })
    })
  }

  return {
    state,
    callApi,
    setIdle
  }
}
